module.exports = __webpack_public_path__ + "img/course102.1e3fbca1.png";